import React from 'react'
import { Switch, Route } from 'react-router-dom'

import WhatsNewShow from './pages/Show'
import WhatsNewIndex from './pages/Index'

const WhatsNew = () => {
    return (
        <Switch>
            <Route path="/whatsnew" exact component={WhatsNewIndex} />
            <Route path="/whatsnew/:slug" component={WhatsNewShow} />
        </Switch>
    )
}

export default WhatsNew
